const nbNO = {
  navigation: {
    mydevice: "Min enhet",
    mymobile: "Min mobil"
  },
  photoorganiser: {
    navigation: {
      photos: "Bilder",
      favorites: "Favoritter",
      collections: "Album",
      events: "Hendelser",
      latestuploads: "Siste overførte bilder"
    },
    empty(source) {
      return "Du har ingen bilder i " + source
    }
  },
  mymobile: {
    title: "Hent dine mobilbilder på 1-2-3",
    qrcode: {
      title: "Skann QR-koden",
      subtitle: "(Du trenger ikke laste ned appen)"
    },
    instruction: {
      title: "La oss starte",
      step_1: "Åpne ditt mobilkamera",
      step_2: "Skann QR-koden",
      step_3: "Følge instruksene på din mobil"
    }
  },
  layout: {
    flex: "Fleksibel",
    square: "Kvadratisk"
  },
  calender: {
    allmonths: "Alle måneder",
    allyears: "Alle år",
    months: {
      january: "Januar",
      february: "Februar",
      march: "Mars",
      april: "April",
      may: "Mai",
      june: "Juni",
      july: "Juli",
      august: "August",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "Desember"
    }
  },
  generic: {
    sortBy: "Sorter etter",
    selected: "valgt",
    done: "Legg til bilder",
    back: "Tilbake",
    images: "bilder",
    selection: "Utvalg",
    date: "Dato",
    name: "Navn",
    az: "Filnavn A-Å",
    za: "Filnavn Å-A",
    newestfirst: "Dato nyeste-eldste",
    oldestfirst: "Dato eldste-nyeste",
    photos: "bilder",
    all: "Alle",
    yes: "Ja",
    no: "Nei",
    nodate: "Uten dato"
  },
  rangeText: {
    minMax(min, max) {
      return "Du må velge mellom " + min + " og " + max + " bilder"
    },
    min(min) {
      return "Du trenger minst " + min + " bilder for å lage boken din."
    },
    max(max) {
      return "Du kan velge maksimalt " + max + " bilder"
    }
  },
  addMorePhotos: "Legg til flere bilder",
  upload: {
    browseButton: "Legg til bilder",
    uploadlimit(maxSize) {
      return "Bildene må være mindre enn " + maxSize + " i filstørrelse"
    },
    dragImage: "eller dra og slipp bilder her.",
    errors: {
      GENERIC_ERROR: "Ukjent feil. Vennligst prøv igjen eller kontakt kundeservice.",
      EMPTY_FILE: "Bildereferanse tapt, vennligst legg til bildet på nytt",
      MAX_FILE_SIZE: "Filen må være mindre enn {0} mb",
      UNSUPPORTED_FILE_TYPE: "Filformatet støttes ikke",
      MAX_IMAGE_RESOLUTION: "Filen må være mindre enn {0} pixels",
      INVALID_IMAGE: "Filen er ødelagt"
    },
    errorSummary(number) {
      return number + " filer kunne ikke lastes opp"
    },
    errorDialog: {
      headline: "Oops!",
      ingress: "Følgende filer kunne ikke lastes opp:",
      filenameColumn: "Fil",
      reasonColumn: "Årsak"
    },
    uploaded: "Lastet opp",
    estimating: "Beregner tid",
    estimatedleft: "Gjenstående tid",
    ok: "OK",
    cancel: "Avbryt",
    details: "Detaljer"
  }
}

export default nbNO
